import React from 'react';
import InfoVideo from './InfoVideo';

export const Info_minting = ({ }) => {
  return (
    <>
      <h5>Basic Guide to Minting TODEM Tiles as NFTs</h5>

      <div className="info-line-container">
        <span className="info-line"></span>
      </div>

      <br></br>
      <br></br>
      <h6>1. Set Up a Digital Wallet:</h6> The first step is to set up a
      digital wallet, which is an application that allows you to interact
      with the blockchain. We recommend using  
      <a
        href="https://metamask.io/download/"
        rel="noreferrer"
        target="_blank"
      >
        {' '}MetaMask
      </a> 
      , a popular wallet
      that works as a browser extension. Download it from the official website
      and follow the instructions to set up a new wallet.
      <br></br>
      <br></br>
      <h6>2. Buy Ethereum (ETH):</h6> Once your wallet is set up, you'll
      need to purchase Ethereum (ETH), the cryptocurrency used for
      transactions on the Ethereum blockchain. You can buy ETH directly
      through the MetaMask wallet or from a cryptocurrency exchange, like
        <a
        href="https://www.coinbase.com/"
        rel="noreferrer"
        target="_blank"
      >
        {' '}Coinbase
      </a> 
      . After purchasing, you'll need to transfer the ETH to your
      MetaMask wallet if you bought it on an exchange.
      <br></br>
      <br></br>
      <h6>3. Connect to the TODEM Minting Platform:</h6> Use the "connect
      wallet" dropdown on the top right to connect your Ethereum wallet to
      the <i>TODEM</i> site (ensure MetaMask is installed on this browser).
      You'll be prompted to connect your digital wallet and approve the
      connection in your MetaMask notification.
      <br></br>
      <br></br>
      <h6>4. Select a Tile to Mint:</h6> Browse the collection of <i>TODEM</i> Tiles and select the one you wish to mint as an NFT. Click on the
      Tile for more details and click on the 'mint' button if you decide
      to proceed. (See 
        <a
        href="https://www.latentculture.com/todem/info.nav"
        rel="noreferrer"
        target="_blank"
      >
        {' '}navigation
      </a> and
      <a
        href="and https://www.latentculture.com/todem/info.pricing"
        rel="noreferrer"
        target="_blank"
      >
        {' '}pricing 
      </a> for more details on Tile
      selection and availability).
      <br></br>
      <br></br>
      <h6>5. Confirm the Transaction:</h6> After clicking 'mint', a wallet
      notification will pop up asking you to confirm the transaction. It
      will display the amount of ETH required for the minting process. If
      you agree with the terms, click 'Confirm'.
      <br></br>
      <br></br>
      <h6>6. Wait for Transaction to Complete:</h6> The Ethereum network
      needs to confirm the transaction. This can take anywhere from a few
      seconds to several minutes, depending on network congestion. Once
      the transaction is confirmed, the NFT is officially minted and
      belongs to you!
      <br></br>
      <br></br>
      <h6>7. View Your NFT:</h6> You can always view your Tile on the <i>TODEM</i> website. 
      The url for your
      Tile is{' '}
      <a className="break">
        https://latentculture.com/todem/four_digit_tile_number
      </a>
      . You can also view your newly minted Tile in your MetaMask wallet
      or through an NFT viewing platform like
      <a
        href="https://opensea.io/"
        rel="noreferrer"
        target="_blank"
      >
        {' '}OpenSea
      </a> 
      .
      <br></br>
      <br></br>
      <h6>8. Download Your Collector Package:</h6> Every Tile you mint comes with a Collector Package featuring 9 MP4s, 3 JPEGs, a metadata file, and more, depending on the class of your Tile. Download your Collector Package from the popout window when you mint your Tile, or by visiting your Tile on the <i>TODEM</i> website. Read more about the Collector Package and benefits 
      <a
        href="https://www.latentculture.com/todem/info.pckg"
        rel="noreferrer"
        target="_blank"
      >
        {' '}here
      </a> 
      .
      <br></br>
      <br></br>
      <h6>9. Claim Your TPX:</h6> When you mint a Tile, you are automatically given TPX coins in proportion to the number of pixels in your Tile, plus a class based multiplier. Claim your TPX and read more about them 
      <a
        href="https://www.latentculture.com/todem/info.TPX"
        rel="noreferrer"
        target="_blank"
      >
        {' '}here
      </a>. 
      <br></br>
      <br></br>
      <h6>Notes:</h6>Remember, minting NFTs involves transaction costs
      (called gas fees) that we do not control and the cost of the NFT
      itself. Ensure you have enough ETH in your wallet to cover these
      costs.
      <br></br>
      <br></br>
      Always keep your wallet's private keys secure and private. If
      someone else gains access to them, they can access your wallet and
      your NFTs.
      <br></br>
      <br></br>
      Blockchain and NFTs are still emerging technologies with risks
      associated with them. Please do your own research and make sure
      you're comfortable with these risks before proceeding.
      <br></br>
      <br></br>
      <h5>Minting FAQ</h5>
      <div className="info-line-container">
        <span className="info-line"></span>
      </div>
      <br></br>
      <br></br>
      <h6>What is my "Collector Package"?</h6>
      It's a specially made archive containing all of the files
      associated with your NFT. It contains representative images,
      a custom metadata file, and video files (low, high, and native
      resolution) for v14, v42, and v56 of your Tile. You can find a link to 
      your package in the popout for your Tile{' '}
      <a className="break">
      (https://latentculture.com/todem/four_digit_tile_number)     
      </a> and read more 
      <a
        href="https://www.latentculture.com/todem/info.pckg"
        rel="noreferrer"
        target="_blank"
      >
        {' '} here
      </a>.
      <br></br>
      <br></br>
      <h6>Can I mint subtiles? </h6>
      Sorry, only whole Tiles are available for acquisition. However,
      there are a variety of Tiles at an excessive range of sizes and mint
      prices.
      <br></br>
      <br></br>
      <h6>After I mint a Tile, can I sell it?</h6>
      Yes, it's yours and you can sell it on the secondary market.
      <br></br>
      <br></br>
      <h6>After I mint a Tile, can I change its contents? </h6>
      Nah, not in this project, but perhaps in the future...
      <br></br>
      <br></br>
      <h6>Elsewhere, you mentioned a charity wallet? </h6>
      Yes, we are routing a percentage of every minted Class A (10%) and B
      (5%) Tile to a charity wallet. We are evaluating where this can be
      best used, but favor structural reform. Particularly, improvements
      to the primary electoral system via Ranked Choice Voting (and its
      variants) could help address dangerous polarities emerging in the
      US.
      <br></br>
      <br></br>
    </>
  )
}

export default Info_minting;